export const SectionHeading = ({
  eyebrow,
  title,
  subtitle,
  align = "center",
  testId,
}) => {
  const alignCls = align === "left" ? "text-left" : "text-center mx-auto";
  return (
    <div className={`${alignCls} max-w-3xl mb-8 md:mb-16`} data-testid={testId}>
      {eyebrow ? (
        <p className="text-sm font-semibold uppercase tracking-widest text-goc-primary mb-3">
          {eyebrow}
        </p>
      ) : null}
      <h2 className="text-3xl md:text-4xl lg:text-[2.75rem] font-bold tracking-tight text-goc-text leading-tight">
        {title}
      </h2>
      {subtitle ? (
        <p className="mt-4 text-base md:text-lg text-goc-muted leading-relaxed">
          {subtitle}
        </p>
      ) : null}
    </div>
  );
};

export default SectionHeading;
